import { render } from "./ProductGranted.vue?vue&type=template&id=3414477e"
import script from "./ProductGranted.vue?vue&type=script&lang=js"
export * from "./ProductGranted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__